/**
 * Get the role name if we send the role id
 * @param {*} organizationRoles
 * @param {*} organizationRoleId
 * @returns
 */
export const getRoleNameById = (organizationRoles = [], organizationRoleId) => {
  const foundRole = organizationRoles.find(
    ({ _id }) => _id === organizationRoleId
  );
  return foundRole ? foundRole.role : "";
};

/**
 * Get all the permission's names if we send the ids
 * @param {*} organizationPermissions
 * @param {*} organizationUserPermissions
 * @returns
 */
export const getPermissionNamesByIds = (
  organizationPermissions = [],
  organizationUserPermissions
) => {
  const permissionNames = organizationUserPermissions.map((permissionId) => {
    const foundPermission = organizationPermissions.find(
      ({ _id }) => _id === permissionId
    );
    return foundPermission ? foundPermission.permission : "";
  });

  return permissionNames.join(", ");
};

/**
 * Get the id of the role
 * @param {*} roles
 * @param {*} roleTofind
 * @returns
 */
export const getRoleId = (roles, roleTofind) =>
  roles.find(({ role }) => role === roleTofind)._id;

/**
 * Check if the user is a admin or owner of the organization
 * @param {*} organizationRoleId
 * @param {*} ownerRoleId
 * @param {*} adminRoleId
 * @returns
 */
export const getIsAdminOrOwner = (
  organizationRoleId = "",
  ownerRoleId = "",
  adminRoleId = ""
) =>
  organizationRoleId.toString() === ownerRoleId.toString() ||
  organizationRoleId.toString() === adminRoleId.toString();

/**
 * Filter the roles to show in the dropdown, only could be one owner, and if the user is not owner cannot add another admin or owner
 * @param {*} organizationRoles
 * @param {*} roleName
 * @returns
 */
export const getRolesToShow = (organizationRoles = [], roleName) => {
  if (roleName === "Owner") {
    return organizationRoles.filter(({ role }) => role !== "Owner");
  } else {
    return organizationRoles.filter(
      ({ role }) => role !== "Admin" && role !== "Owner"
    );
  }
};

/**
 * Check if we have to use the current user's information or the organization owner's information
 * If the user is an athlete, or the user is not member of an organization the value should be active user if not organization owner
 * @param {*} activeUser
 * @param {*} organizationOwner
 * @returns
 */
export const getUserToRequest = (activeUser, organizationOwner) => {
  const userIsCoach = activeUser?.permissions?.includes("coach");

  const userToRequest =
    (!activeUser?.organizationId && !organizationOwner) || !userIsCoach
      ? activeUser
      : organizationOwner;

  return userToRequest;
};
